import { SubNav } from "../components/subnav-menu";

const SELECTORS = {
  component: ".js-subnav",
};

window.Drupal.behaviors.app_subnav = {
  attach: (context, settings) => {
    const components = [...context.querySelectorAll(SELECTORS.component)];

    for (const component of components) {
      const SubNavInstance = new SubNav(component);

      SubNavInstance.init();
    }
  },
};
